import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { map, Observable, Subject, tap } from "rxjs";
import { IResponseContent } from "../../shared/models/interfaces/responseContent.interface";

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  readonly  snackBar: MatSnackBar = inject(MatSnackBar);
  private readonly _http :HttpClient = inject(HttpClient);

  successSnackBar(message:string){
    this.snackBar.open(message, '', {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'success-snackbar'
    });
  }

  errorSnackBar(message:string):any{
    return this.snackBar.open(message, '', {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'error-snackbar'
    });
  }

  getBadgeNumber():Observable<number>{
    return this._http.get<IResponseContent<number>>('/booking/reservation/get-dynamic-pending-number').pipe(
      map(({ content })=> content),
    );
  }

}